/*jshint esversion: 9 */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import moment from 'moment';

const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //Seafood products - populated from the ProductSection with the slug 'seafood'
        seafoodProductIds: [],

        //list of products that are pickup only (no delivery) - populated form the config
        pickupOnlyProductIds: [],

        //list of items in the cart - form of {id: 0, option: '', title: '', qty: 0, price: 0, unit: 'kg'}
        cart: [],

        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        address: '',
        suburb: '',
        postcode: '',
        promotion: false,
        delivery: '',
        deposit: null,

        location: '',
        pickupAllocated: '',
        pickupPriority: '',

        notes: '',
    },
    getters: {
        cart: state => state.cart,
        firstname: state => state.firstname,
        lastname: state => state.lastname,
        email: state => state.email,
        phone: state => state.phone,
        address: state => state.address,
        suburb: state => state.suburb,
        postcode: state => state.postcode,
        promotion: state => state.promotion,
        delivery: state => state.delivery,
        deposit: state => state.deposit,
        pickupAllocated: state => state.pickupAllocated,
        pickupPriority: state => state.pickupPriority,
        location: state => state.location,
        notes: state => state.notes,

        //Get the rough total of the cart
        //NOTE: Doesn't handle kg unit conversions
        getCartPrice: state => {
            var total = 0;
            for(var i=(state.cart.length-1); i>=0; i--) {
                total += Math.round((state.cart[i].qty * state.cart[i].price) * 100) / 100;
            }
            return total;
        },
        getCartItem: (state) => (productId, option) => {
            return state.cart.find(function(el) {
                if ((el.id == productId) && (el.option == option))
                    return el;
            });
        },

        getSummaryTotal: (state) => {
            var total = 0;
            for(var i=(state.cart.length-1); i>=0; i--) {
                total += state.cart[i].qty;
            }
            return total;
        },

        //Check if the cart has any seafood items
        hasSeafood: state => {
            for(var i=(state.cart.length-1); i>=0; i--) {
                for (var s=(state.seafoodProductIds.length); s>=0; s--) {
                    if (state.seafoodProductIds[s] == state.cart[i].id)
                        return true;
                }
            }
            return false;
        },

        //Check if the cart has any seafood items
        hasPickupOnly: state => {
            for(var i=(state.cart.length-1); i>=0; i--) {
                for (var s=(state.pickupOnlyProductIds.length); s>=0; s--) {
                    if (state.pickupOnlyProductIds[s] == state.cart[i].id)
                        return true;
                }
            }
            return false;
        }

    },
    mutations: {
        setSeafoodProductIds (state, value) { state.seafoodProductIds = value; },
        setPickupOnlyProductIds (state, value) { state.pickupOnlyProductIds = value; },

        setFirstname (state, value) { state.firstname = value; },
        setLastname (state, value) { state.lastname = value; },
        setEmail (state, value) { state.email = value; },
        setPhone (state, value) { state.phone = value; },
        setPromotion  (state, value) { state.promotion = value; },
        setAddress (state, value) { state.address = value; },
        setSuburb (state, value) { state.suburb = value; },
        setPostcode (state, value) { state.postcode = value; },
        setDelivery (state, value) { state.delivery = value; },
        setDeposit (state, value) { state.deposit = value; },
        setPickupAllocated (state, value) { state.pickupAllocated = value; },
        setPickupPriority (state, value) { var date = moment(value); state.pickupPriority = (date.isValid() ? date.format('YYYY-MM-DD') : ''); },
        setLocation (state, value) { state.location = value; },
        setNotes (state, value) { state.notes = value; },

        addToCart (state, payload) {
            //Add or update
            var found = this.getters.getCartItem(payload.id, payload.option);
            
            if (found == undefined) {
                state.cart.push({
                    id: payload.id,
                    option: payload.option,
                    title: payload.title,
                    form_title: payload.form_title,
                    price: payload.price,
                    qty: 1,
                    unit: payload.unit,
                    thumbnail: payload.thumbnail,
                });
            } else {
                found.qty++;
            }

        },
        removeFromCart (state, payload) {
            state.cart = state.cart.filter(function(value, index, arr){
                return !((value.id == payload.id) && (value.option == payload.option));
            });
        },
        increment (state, payload) {
            var found = this.getters.getCartItem(payload.id, payload.option);
            if (found == undefined) return;
            found.qty++;
        },
        decrement (state, payload) {
            var found = this.getters.getCartItem(payload.id, payload.option);
            if (found == undefined) return;
            if (found.qty <= 1) {
                //Remove from cart
                state.cart = state.cart.filter(function(value, index, arr){
                    return !((value.id == payload.id) && (value.option == payload.option));
                });
            } else {
                found.qty--;
            }
        },
        
        reset (state) {
            state.cart = [];
            state.firstname = '';
            state.lastname = '';
            state.email = '';
            state.phone = '';
            state.address = '';
            state.suburb = '';
            state.postcode = '';
            state.promotion = false;
            state.delivery = '';
            state.deposit = null;
            state.deposit = 0;
            state.location = '';
            state.pickupAllocated = '';
            state.pickupPriority = '';
            state.notes = '';
        }
    },
    actions: {
        reset () {
            this.commit('reset');
        }
    },
    plugins: [vuexLocal.plugin]
});